import React from 'react';
import moment from 'moment';

export function DateColumnFormatter(cellContent, showTime = false) {
  const m = moment.utc(cellContent).local();

  return cellContent && (
    <div className={'badge'} style={{
      padding: '6px 12px',
      borderRadius: '999px',
      background: 'rgba(255,255,255,0.35)',
      border: '1px solid rgba(0,0,0,0.45)'
    }}>
      <div className="text-dark-75 font-weight-bolder font-size-lg text-nowrap">
        {cellContent ? m.format('DD-MM-YYYY') : ''}
      </div>
      {showTime &&
        <div className="text-dark-75 font-weight-bolder font-size-lg text-nowrap text-muted">
          {cellContent ? moment.utc(cellContent).local().format('HH:mm:ss') : ''}
        </div>
      }
    </div>
  );
}